import { Shot } from '@/types/greenroom/shots.types';
import { Post } from '../helpers';

const LoadGreenroomShots = async (meetingId: number): Promise<Shot[] | null> => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_API,
    url: '/v2/greenroom/shots/load',
    body: { meetingId },
    includeBlToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    // Note: do not use cache, we need to make sure we always fetch latest data so we don't
    // accidentally send stale updates to greeenroom shot feeds
  });
};

export default LoadGreenroomShots;
